;(function ($) {
	$.fn.naturataMainmenu = function () {
		return $(this).each(function () {
			var container = $(this);
			var body = $('body');
            var scrollUpIndicator = body.find('[data-scroll-up-indicator]');

			var minScrollScrollupIndicator = function () {
				return window.pageYOffset + container.height() > scrollUpIndicator.offset().top;
			};

			var minScrollMainMenu = function() {
				return Math.max(document.documentElement.clientHeight, window.innerHeight || 0) * 0.2;
			};

			var lastScrollTop = 0;
			var getScrollDirection = function(e) {
				var target = e.currentTarget;
				var scrollTop = window.pageYOffset || target.scrollTop;
				var direction;
				if (scrollTop > lastScrollTop) {
					direction = 'down';
				} else {
					direction = 'up';
				}
				lastScrollTop = scrollTop;
				return direction;
			};

			container.scroll(function (e) {
				var scrollTop = window.pageYOffset || e.currentTarget.scrollTop;
				if (getScrollDirection(e) == 'down' && container.scrollTop() > minScrollMainMenu()
				) {
					body.addClass('navigation-visible');
				} else {
					body.removeClass('navigation-visible');
				}

				if(scrollTop > minScrollMainMenu()) {
					body.addClass('logo-smaller');
				} else {
					body.removeClass('logo-smaller');
				}

				if(minScrollScrollupIndicator()) {
					body.addClass('scrollup-indicator-visible');
				} else {
					body.removeClass('scrollup-indicator-visible');
				}
			});
		});
	};
	$(function () {
		$(window).naturataMainmenu();
	});
})(jQuery);

